export const PARKING_CONSTANTS = {
    PARKING_TICKET: 'ParkingTicket',
    MULTI_PURPOSE_CARD: 'MultiPurposeCard',
    MOBILE_TICKET_PAYMENT: 'mobileTicketPayment',
    MULTI_PURPOSE_CARD_CHARGE: 'multiPurposeCardCharge',
}
